import { getMoment } from '@lumapps/utils/time/getMoment';

const moment = getMoment();

export const getFormatedDate = (startDate: string, endDate: string) => {
    const isSameDay = moment(startDate).isSame(endDate, 'day');
    const formatedStartDate = moment(startDate).format('llll');
    const formatedEndDate = isSameDay ? moment(endDate).format('LT') : moment(endDate).format('llll');
    return { formatedStartDate, formatedEndDate };
};
